import applySaveMssageFlow from './applySaveMessageFlow';
import { State } from '../../reducer';
import { Action } from 'redux';
import { Command } from '../actions';
import { fromJS } from 'immutable';
import { MessageFlow } from '../model';

export const PATH_MESSAGE_FLOW = 'message-flow';
export const INITIAL_STATE = fromJS({});

export default (state: MessageFlow.MessageFlow, action: Action): State => {
    switch (action.type) {
        case Command.CMD_SAVE_MESSAGE_FLOW:
            return applySaveMssageFlow(state, action);
        case Command.CMD_START_WATCH_SESSION:
            return state.set('watching', true);
        case Command.CMD_STOP_WATCH_SESSION:
            return state.stopWatching();
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/MessageFlow/reducers/index.ts